import { render } from "./ShipmentDetails.vue.ts?vue&type=template&id=8fbe27b6&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ShipmentDetails.vue?vue&type=template&id=8fbe27b6&scoped=true&ts=true"
import script from "./ShipmentDetails.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ShipmentDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShipmentDetails.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ShipmentDetails.vue?vue&type=script&setup=true&lang=ts"

import "./ShipmentDetails.vue.scss?vue&type=style&index=0&id=8fbe27b6&scoped=true&lang=scss!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ShipmentDetails.vue?vue&type=style&index=0&id=8fbe27b6&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fbe27b6"],['__file',"src/apps/credit-line/components/CreditCard/CardDetails/ShipmentDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8fbe27b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8fbe27b6', __exports__)) {
    api.reload('8fbe27b6', __exports__)
  }
  
  module.hot.accept("./ShipmentDetails.vue.ts?vue&type=template&id=8fbe27b6&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ShipmentDetails.vue?vue&type=template&id=8fbe27b6&scoped=true&ts=true", () => {
    api.rerender('8fbe27b6', render)
  })

}


export default __exports__